module.exports = __webpack_public_path__ + "assets/sprr.net.ee3250d71311b3abf055c2318f98d1df22d837272ae7f2efb32b60eaea767121.jpg";